import request from '@api/request';

export const loginApi = async (params) =>
  await request({
    url: '/login',
    type: 'post',
    params,
  });

export const registerApi = async (params) =>
  await request({
    url: '/signup',
    type: 'post',
    params,
  });

export const authApi = async () =>
  await request({
    url: '/auth-user',
    type: 'get',
  });
